module.exports = __webpack_public_path__ + "media/images/panel_ter/logo-87435eeffe8a242c6b75869f2180f4e3.png";